import { render, staticRenderFns } from "./PainCareInfoModal.vue?vue&type=template&id=b9a7e856&scoped=true&"
import script from "./PainCareInfoModal.vue?vue&type=script&lang=js&"
export * from "./PainCareInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./PainCareInfoModal.vue?vue&type=style&index=0&id=b9a7e856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a7e856",
  null
  
)

export default component.exports